

export default {
  methods: {
    isTrueValue: function (value) {
      return this.trueValues.indexOf(value) !== -1
    },
    isNotDefined: function (value) {
      return value === null || value === undefined || value === ''
    },
    isSDD: function (id) {
      return this.sddIds.indexOf(id) !== -1
    },
    isCard: function (id) {
      return id === 4 || id === '4'
    },
    isPISP: function (id) {
      return id === 11 || id === '11'
    },
    isIbanHorsEU: function (ibanCountryCode, bicId) {
      let country = this.euCountries.find(i => i.id === ibanCountryCode.toUpperCase() && i.bicId === bicId.toUpperCase())
      return !country
    },
    isSepaIban: function (ibanCountryCode) {
      let country = this.sepaCountries.find(i => i.alpha2 === ibanCountryCode.toLowerCase())
      return !!country
    },
    countryByAlpha2: function (_id) {
      let id = _id
      if (id && id.length > 2) id = id.slice(0,2)
      return this.sepaCountries.find(i => i.alpha2 === id.toLowerCase())
    },
    countryByName: function (name) {
      if (!name) return false
      return this.sepaCountries.find(i => i.name.toLowerCase() === name.toLowerCase())
    },
  },
  data: function () {
    return {
      trueValues: [
        true,
        'true',
        'Y',
        'y',
        1,
        '1'
      ],
      sddIds: [
        1,
        6,
        '1',
        '6'
      ],
      euCountries: [
        { id: 'AD', bicId: 'AD', name: 'Andorra' },
        { id: 'AT', bicId: 'AT', name: 'Autriche' },
        { id: 'BE', bicId: 'BE', name: 'Belgique' },
        { id: 'CY', bicId: 'CY', name: 'Chypre' },
        { id: 'EE', bicId: 'EE', name: 'Estonie' },
        { id: 'FI', bicId: 'FI', name: 'Finlande' },
        { id: 'FR', bicId: 'FR', name: 'France' },
        { id: 'FR', bicId: 'GF', name: 'Guyane Française' },
        { id: 'FR', bicId: 'GP', name: 'Guadeloupe' },
        { id: 'FR', bicId: 'MQ', name: 'Martinique' },
        { id: 'FR', bicId: 'RE', name: 'Réunion' },
        { id: 'FR', bicId: 'BL', name: 'Saint Barthélemy' },
        { id: 'DE', bicId: 'DE', name: 'Allemagne' },
        { id: 'GR', bicId: 'GR', name: 'Grèce' },
        { id: 'IE', bicId: 'IE', name: 'Irelande' },
        { id: 'IT', bicId: 'IT', name: 'Italie' },
        { id: 'LV', bicId: 'LV', name: 'Lettonie' },
        { id: 'LT', bicId: 'LT', name: 'Lituanie' },
        { id: 'LU', bicId: 'LU', name: 'Luxembourg' },
        { id: 'MT', bicId: 'MT', name: 'Malte' },
        { id: 'NL', bicId: 'NL', name: 'Pays-Bas' },
        { id: 'PT', bicId: 'PT', name: 'Portugal' },
        { id: 'SM', bicId: 'SM', name: 'San Marin' },
        { id: 'SK', bicId: 'SK', name: 'Slovaquie' },
        { id: 'SI', bicId: 'SI', name: 'Slovénie' },
        { id: 'ES', bicId: 'ES', name: 'Espagne' }
      ],
      sepaCountries: [
        { id: 'AX', alpha2: 'ax', alpha3: 'ALA', name: 'Îles Åland' },
        { id: 'AD', alpha2: 'ad', alpha3: 'AND', name: 'Andorra', hasProvince: true },
        { id: 'DE', alpha2: 'de', alpha3: 'DEU', name: 'Allemagne' },
        { id: 'AT', alpha2: 'at', alpha3: 'AUT', name: 'Autriche' },
        { id: 'PT', alpha2: 'pt', alpha3: 'PRT', name: 'Azores' },
        { id: 'BE', alpha2: 'be', alpha3: 'BEL', name: 'Belgique' },
        { id: 'BG', alpha2: 'bg', alpha3: 'BGR', name: 'Bulgarie' },
        { id: 'ES', alpha2: 'es', alpha3: 'ESP', name: 'Îles Canaries' },
        { id: 'CY', alpha2: 'cy', alpha3: 'CYP', name: 'Chypre' },
        { id: 'HR', alpha2: 'hr', alpha3: 'HRV', name: 'Croatie' },
        { id: 'DK', alpha2: 'dk', alpha3: 'DNK', name: 'Danemark' },
        { id: 'EE', alpha2: 'ee', alpha3: 'EST', name: 'Estonie' },
        { id: 'ES', alpha2: 'es', alpha3: 'ESP', name: 'Espagne', hasProvince: true },
        { id: 'VA', alpha2: 'va', alpha3: 'VAT', name: 'État de la Cité du Vatican', hasProvince: true },
        { id: 'FI', alpha2: 'fi', alpha3: 'FIN', name: 'Finlande' },
        { id: 'FR', alpha2: 'fr', alpha3: 'FRA', name: 'France' },
        { id: 'GI', alpha2: 'gi', alpha3: 'GIB', name: 'Gibraltar', hasProvince: true },
        { id: 'GR', alpha2: 'gr', alpha3: 'GRC', name: 'Grèce' },
        { id: 'FR', alpha2: 'gp', alpha3: 'GLP', name: 'Guadeloupe' },
        { id: 'GB', alpha2: 'gg', alpha3: 'GGY', name: 'Guernsey', hasProvince: true },
        { id: 'FR', alpha2: 'gf', alpha3: 'GUF', name: 'Guyane Française' },
        { id: 'HU', alpha2: 'hu', alpha3: 'HUN', name: 'Hongrie' },
        { id: 'GB', alpha2: 'im', alpha3: 'IMN', name: 'Île de Man', hasProvince: true },
        { id: 'IE', alpha2: 'ie', alpha3: 'IRL', name: 'Irlande', hasProvince: true },
        { id: 'IS', alpha2: 'is', alpha3: 'ISL', name: 'Islande', hasProvince: true },
        { id: 'IT', alpha2: 'it', alpha3: 'ITA', name: 'Italie', hasProvince: true },
        { id: 'GB', alpha2: 'je', alpha3: 'JEY', name: 'Jersey', hasProvince: true },
        { id: 'LV', alpha2: 'lv', alpha3: 'LVA', name: 'Lettonie' },
        { id: 'LI', alpha2: 'li', alpha3: 'LIE', name: 'Liechtenstein', hasProvince: true },
        { id: 'LT', alpha2: 'lt', alpha3: 'LTU', name: 'Lithuanie' },
        { id: 'LU', alpha2: 'lu', alpha3: 'LUX', name: 'Luxembourg' },
        { id: 'PT', alpha2: 'pt', alpha3: 'PRT', name: 'Madeire' },
        { id: 'MT', alpha2: 'mt', alpha3: 'MLT', name: 'Malta' },
        { id: 'FR', alpha2: 'mq', alpha3: 'MTQ', name: 'Martinique' },
        { id: 'FR', alpha2: 'yt', alpha3: 'MYT', name: 'Mayotte' },
        { id: 'MC', alpha2: 'mc', alpha3: 'MCO', name: 'Monaco', hasProvince: true },
        { id: 'NO', alpha2: 'no', alpha3: 'NOR', name: 'Norvège', hasProvince: true },
        { id: 'NL', alpha2: 'nl', alpha3: 'NLD', name: 'Pays-Bas' },
        { id: 'PL', alpha2: 'pl', alpha3: 'POL', name: 'Pologne' },
        { id: 'PT', alpha2: 'pt', alpha3: 'PRT', name: 'Portugal' },
        { id: 'CZ', alpha2: 'cz', alpha3: 'CZE', name: 'République tchèque' },
        { id: 'FR', alpha2: 're', alpha3: 'REU', name: 'Réunion' },
        { id: 'RO', alpha2: 'ro', alpha3: 'ROU', name: 'Roumanie' },
        { id: 'GB', alpha2: 'gb', alpha3: 'GBR', name: 'Royaume-Uni', hasProvince: true },
        { id: 'FR', alpha2: 'bl', alpha3: 'BLM', name: 'Saint Barthélemy' },
        { id: 'FR', alpha2: 'mf', alpha3: 'MAF', name: 'Saint Martin' },
        { id: 'SM', alpha2: 'sm', alpha3: 'SMR', name: 'San Marin', hasProvince: true },
        { id: 'FR', alpha2: 'pm', alpha3: 'SPM', name: 'Saint Pierre and Miquelon' },
        { id: 'SK', alpha2: 'sk', alpha3: 'SVK', name: 'Slovaquie' },
        { id: 'SI', alpha2: 'si', alpha3: 'SVN', name: 'Slovénie' },
        { id: 'SE', alpha2: 'se', alpha3: 'SWE', name: 'Suède' },
        { id: 'CH', alpha2: 'ch', alpha3: 'CHE', name: 'Suisse' }
      ]
    }
  }
}

//   1,'SDD', 'SDD', 'Sepa direct debit');
// 2,'SCT', 'SCT', 'Sepa credit transfert');
// 3,'transfer', 'INT', 'internal transfer');
// 4,'card', 'CARD', 'carte');
// 5,'swift', 'MT103', 'SWIFT Single Customer Credit Transfer');
// 6,'SDD B2B', 'SDD B2B', 'Sepa direct debit B2B');
// 7,'L/C', 'L/C', 'Letter of credit');
// ]